import { Button } from 'components/buttons';
import { DialogContent, DialogFooter } from 'components/dialog/dialog';
import styled from 'styled-components';

export const CancelDialogContent = styled(DialogContent).attrs({
  className: 'max-w-md',
})``;

export const CancelDialogFooter = styled(DialogFooter).attrs({
  className: 'gap-2 sm:gap-2',
})``;

export const KeepRecordingButton = styled(Button).attrs({
  variant: 'outline',
  className: 'w-full sm:w-auto',
})``;

export const ConfirmCancelButton = styled(Button).attrs({
  variant: 'destructive',
  className: 'w-full sm:w-auto',
})``;
